var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoHc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 87,
    viewBox: "0 0 88 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.7559 76.2539H13.2441C6.21736 76.2539 0.5 70.6023 0.5 63.6562V23.3438C0.5 16.3977 6.21736 10.7461 13.2441 10.7461H74.7559C81.7826 10.7461 87.5 16.3977 87.5 23.3438V63.6562C87.5 70.6023 81.7826 76.2539 74.7559 76.2539Z",
    fill: "#FD7296"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 76.2539H74.7559C81.7826 76.2539 87.5 70.6023 87.5 63.6562V23.3438C87.5 16.3977 81.7826 10.7461 74.7559 10.7461H44V76.2539Z",
    fill: "#FC3E6F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3535 58.6174C35.9279 58.6174 35.5022 58.5116 35.1189 58.3024C34.3075 57.8572 33.8047 57.0131 33.8047 56.0979V30.9025C33.8047 29.9873 34.3075 29.1432 35.1189 28.6979C35.9204 28.255 36.9185 28.2772 37.7051 28.7668L58.0957 41.3645C58.84 41.8245 59.293 42.6316 59.293 43.5002C59.293 44.3688 58.84 45.1758 58.0957 45.6359L37.7051 58.2336C37.2918 58.4894 36.824 58.6174 36.3535 58.6174Z",
    fill: "#FAFBFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44 54.3447L58.0957 45.6362C58.84 45.1761 59.293 44.369 59.293 43.5005C59.293 42.6319 58.84 41.8248 58.0957 41.3648L44 32.6562V54.3447Z",
    fill: "#DAE1E8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoHc);
export default __webpack_public_path__ + "static/media/videoHC.3fd2824a808d0b2703e833a85c665914.svg";
export { ForwardRef as ReactComponent };